/**
 * Application-wide constants
 */

// Auth / Session
export const SESSION_CHECK_INTERVAL_MS = 60_000; // 1 minute

// Image upload
export const MAX_IMAGE_DIMENSION = 1024;
export const DEFAULT_IMAGE_SIZE = '1024x1024';

// Design editor
export const CANVAS_WIDTH = 500;
export const CANVAS_HEIGHT = 500;

// Pricing defaults
export const DEFAULT_SHIPPING_COST = 49;
export const DEFAULT_FREE_SHIPPING_THRESHOLD = 500;
export const DEFAULT_TAX_RATE = 25;
